export const COPY: { [key: string]: string } = {
  heading: 'Your utility providers',
};

export const CARD_CONTENT: { [key: string]: string } = {
  visitWebsite: 'Visit website',
};

export const UTILITIES = {
  gas: 'Gas',
  electric: 'Electric',
  water: 'Water',
};

export const ERROR_PAGE_COPY = {
  TITLE: 'Oops... Our system is having some trouble.',
  DESCRIPTION: 'In the meantime, keep going on your other moving tasks.',
  CTA: 'Back to home',
};
